<template>
  <div class="activity-examine-page">
    <van-tabs
      v-model="activeName"
      title-active-color="#3283fa"
      color="#3283fa"
      :sticky="true"
      :swipe-threshold="3"
      @change="setType"
    >
      <van-tab
        :name="type.value"
        v-for="(type, key) in types"
        :key="type.title"
        :title="type.title"
      ></van-tab>
    </van-tabs>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="— 暂无更多数据 —"
      @load="onLoad"
      class="list"
      :offset="1"
      :immediate-check="false"
    >
      <!-- 人员列表 -->
      <div
        class="item bottom-line"
        v-for="(item, index) in ExamineList"
        :key="item.id"
      >
        <div class="detail">
          <img :src="item.avatar ? item.avatar : avatarUrl" alt />
          <div class="task-info">
            <span class="first">
              <span class="task-name">{{ item.kpiName }}</span>
              <span>(KpiId：{{ item.id || "" }})</span>
            </span>
            <span v-if="item.type === 'act'">活动负责人</span>
            <span v-if="item.type === 'brand'">品牌负责人</span>
            <span v-if="item.type === 'staff'">导购员</span>
            <span class="mobile">{{ item.mobile }}</span>
            <span class="time">{{ item.createTime }}</span>
          </div>
        </div>
        <div class="btn">
          <van-button
            size="small"
            round
            type="info"
            v-if="activeName == 'under_review'"
            @click.stop="ConfirmSetAuditStatus(item.id, 'pass')"
            >通过</van-button
          >
          <van-button
            size="small"
            round
            class="refuse"
            v-if="activeName == 'under_review'"
            @click.stop="ConfirmSetAuditStatus(item.id, 'no_pass')"
            >拒绝</van-button
          >
          <van-button size="small" round type="info" v-if="activeName == 'pass'"
            >已通过</van-button
          >
          <van-button
            size="small"
            round
            class="refuse"
            v-if="activeName == 'no_pass'"
            >已拒绝</van-button
          >
        </div>
        <!-- <div class="btn" v-if="item.status === 2">
              <van-button size="small" round class="pass" @click.stop="">已通过</van-button>
            </div>
            <div class="btn" v-if="item.status === 3">
              <van-button size="small" round class="refused" @click.stop="">已拒绝</van-button>
        </div>-->
      </div>
    </van-list>

    <div class="home-over-btn">
      <router-link
        :to="{
          name: 'kpi.home',
          query: { user_id: user_id, kpi_uid: kpi_userid, act_id: activity_id },
        }"
      >
        <img src="https://j.weizan.cn/youxiang/images/home-over.png" />
        首页
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activity_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      user_id: localStorage.getItem("user_id"),
      kpi_userid: localStorage.getItem("kpi_user_id") || null,
      activity: {},
      // user_id: 0,
      kpi_uid: 0,
      share_uid: 0,
      user: null,
      kpi_user: null,
      typeIndex: 0,
      types: [
        { title: "审核中", value: "under_review", list: [] },
        { title: "已通过", value: "pass", list: [] },
        { title: "已拒绝", value: "no_pass", list: [] },
      ],
      show: false,
      page: 1,
      loading: false,
      finished: true,
      count: 0,
      nowpage: 1,
      activeName: "under_review",
      ExamineList: [],
      avatarUrl: "https://j.weizan.cn/youxiang/images/avatar_default.jpg",
    };
  },
  computed: {
    status() {
      return this.typeIndex + 1;
    },
  },
  created() {
    this.getQueryKpiuserByStatus();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    async getQueryKpiuserByStatus() {
      var act = {
        page: this.nowpage,
        size: 10,
        status: this.activeName,
      };
      let res = await this.$http.post(
        `/v1/kpiuser/query_kpiuser_by_status?page=${act.page}&size=${act.size}&status=${act.status}`
      );
      console.log(res);
      if (res.data) {
        var list = res.data.list;
        if (this.nowpage === 1) {
          this.ExamineList = list || [];
        } else {
          this.ExamineList = this.ExamineList.concat(list);
        }
        this.count = res.data.total;
      } else {
        this.finished = true;
      }
    },
    // 上滑加载
    onLoad() {
      console.log(233);
      // 获取当前的总条数，当前页数。
      // 如果条数除以10向上取整，大于当前页数，则执行一次加载
      if (Math.ceil(this.count / 10) > this.nowpage) {
        this.nowpage = this.nowpage + 1;
        this.getQueryKpiuserByStatus();
      } else {
        if (this.nowpage != 1) {
          this.finished = true;
        }
      }
      // 加载状态结束
      this.loading = false;
    },
    ConfirmSetAuditStatus(Id, Status) {
      var self = this;
      var message = "";
      if (Status == "pass") {
        message = "同意该用户通过吗？";
      } else if (Status == "no_pass") {
        message = "拒绝该用户通过吗？";
      }
      this.$dialog
        .confirm({
          title: "人员审核",
          message: message,
        })
        .then(() => {
          this.UpdateKpiuserStatus(Id, Status);
        })
        .catch(() => {});
    },
    // 审核操作
    async UpdateKpiuserStatus(Id, Status) {
      await this.$http.post(
        `/v1/kpiuser/update_kpiuser_status?id=${Id}&status=${Status}`
      );
      this.$toast("操作成功！");
      await this.setType();
    },
    // 切换审核状态
    setType(index) {
      this.loading = false;
      this.finished = false;
      this.nowpage = 1;
      this.count = 0;
      this.ExamineList = [];
      this.getQueryKpiuserByStatus();
    },
    goDetail(item) {
      this.$router.push({
        name: "kpi.examine.detail",
        params: { user_id: item.id },
        query: {
          activity_id: this.activity.id,
          user_id: this.user_id,
          kpi_uid: this.kpi_uid,
          share_uid: this.share_uid,
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.activity-examine-page {
  .list {
    margin-top: 10px;
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #ffffff;
      padding: 10px;
      .detail {
        display: flex;
        flex: 1;
        justify-content: flex-start;
        align-items: center;
        img {
          width: 50px;
          min-width: 50px;
          max-width: 50px;
          height: 50px;
          border-radius: 50%;
          margin-right: 10px;
        }
        .task-info {
          display: flex;
          flex-direction: column;
          font-size: 12px;
          line-height: 18px;
          .first {
            font-size: 14px;
            .task-name {
              font-weight: bold;
            }
          }
          .mobile {
            color: #666666;
          }
          .time {
            color: #999999;
          }
        }
      }
      .btn {
        .refuse {
          /*拒绝按钮*/
          background-color: #f58022;
          color: #ffffff;
        }
        .pass {
          /*已操作按钮*/
          background-color: #b3b3b3;
          color: #ffffff;
        }
        .refused {
          background-color: #ffa8a8;
          color: #ffffff;
        }
        .van-button--small {
          margin-right: 3px;
          height: 24px;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
